import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { Box, Button, IconButton, Stack, Tooltip, Typography } from '@mui/material';

import {
  MIN_LONG,
  IS_REQUIRED,
  NEED_VALID_EMAIL,
  WRONG_EMAIL_OR_PASSWORD,
} from '../../helpers/constants';
import { useAuth } from '../../hooks/useAuth';
import { Input } from '../../components/Input';
import { COLORS_CONST, loginStyle } from '../../helpers/styles';
import { InfoOutlined } from '@mui/icons-material';

enum LoginFields {
  email = 'user',
  password = 'password',
}

export const Login = () => {
  const { login } = useAuth();

  const initialValues = {
    [LoginFields.email]: '',
    [LoginFields.password]: '',
  };

  const validationSchema = yup.object({
    [LoginFields.email]: yup.string().email(NEED_VALID_EMAIL).required(IS_REQUIRED),
    [LoginFields.password]: yup.string().required(IS_REQUIRED).min(8, MIN_LONG),
  });

  const { values, errors, touched, handleChange, setErrors, handleSubmit } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async values => {
      try {
        const data = await login({
          user: values[LoginFields.email],
          password: values[LoginFields.password],
        });
        if (data) {
          console.log('succerss');
        } else {
          setErrors({
            // [LoginFields.email]: WRONG_EMAIL_OR_PASSWORD,
            [LoginFields.password]: WRONG_EMAIL_OR_PASSWORD,
          });
        }
      } catch (error: any) {
        setErrors({
          [LoginFields.email]: error.graphQLErrors[0].debugMessage,
          [LoginFields.password]: error.graphQLErrors[0].debugMessage,
        });
      }
    },
  });

  return (
    <Stack
      spacing={3}
      flexGrow={1}
      paddingY={20}
      component="form"
      paddingLeft={10}
      paddingRight={10}
      onSubmit={handleSubmit}
    >
      <Input
        type="email"
        label="email"
        width="350px"
        placeholder={'email'}
        onChange={handleChange}
        name={LoginFields.email}
        value={values[LoginFields.email]}
        error={touched[LoginFields.email] && !!errors[LoginFields.email]}
        helperText={touched[LoginFields.email] && errors[LoginFields.email]}
      />

      <Input
        width="350px"
        label="password"
        isPassword={true}
        onChange={handleChange}
        placeholder={'password'}
        name={LoginFields.password}
        value={values[LoginFields.password]}
        error={touched[LoginFields.password] && !!errors[LoginFields.password]}
        helperText={touched[LoginFields.password] && errors[LoginFields.password]}
      />
      <Button variant="contained" sx={{ ...loginStyle, height: '50px' }} type="submit">
        Войти
      </Button>
      <Box width="350px" display="flex" justifyContent="space-between" alignItems="flex-end">
        <Button href="https://www.basis-opora.ru/kontakty/">
          <Typography
            fontStyle="italic"
            fontSize="1.3em"
            color={COLORS_CONST.basic}
            textTransform="none"
          >
            Создать аккаунт...
          </Typography>
        </Button>
        <Tooltip
          arrow
          title={
            <Typography>
              Для регистрации в калькуляторе расчета опор, пожалуйста обратитесь в компанию BASIS по
              контактам указанным на странице https://www.basis-opora.ru/kontakty/
            </Typography>
          }
        >
          <IconButton
            sx={{ color: COLORS_CONST.basic }}
            href="https://www.basis-opora.ru/kontakty/"
            target="_blank"
          >
            <InfoOutlined />
          </IconButton>
        </Tooltip>
      </Box>

      {/*<Box {...loginStyle} display="flex" justifyContent="flex-end">
        <Button type="submit" onClick={() => navigate(`/${PatchesName.User}`)}>
          <Typography
            fontStyle="italic"
            fontSize="1.3em"
            color={COLORS_CONST.basic}
            textTransform="none"
          >
            Создать аккаунт...
          </Typography>
        </Button>
      </Box>*/}
    </Stack>
  );
};
